import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import { postApi } from '../../lib/fetcher';
import state from './state';
import mutations from './mutations';
import api from './constants';
import { showAlert } from '../../lib/helpers';

const promo = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const version = generateVersionHash(itemsPerPage.toString() + page.toString(), date);

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'id DESC',
        version
      });

      const urlApi = api.GET_PROMO_LIST;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getMerchantPromo(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, promoId }
    ) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearDataMerchantPromo');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'rrn'} ${sort}`;

      const version = generateVersionHash(itemsPerPage.toString() + page.toString(), date);
      const data = JSON.stringify({
        page: page.toString(),
        promo_id: promoId,
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version
      });

      const urlApi = api.GET_MID_LIST_PROMO;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalDataMerchantPromo', { payload: responseData });
        ctx.commit('setDataMerchantPromo', { payload: responseData });
      }
    },

    async getDetail(ctx, { id, date }) {
      ctx.commit('setLoading', true);

      const version = generateVersionHash(date);
      const data = JSON.stringify({
        id,
        version
      });

      const urlApi = api.GET_DETAIL_PROMO;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setItem', { payload: responseData });
      }
    },
    async getMerchant(ctx, { date, sortBy, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearDataMerchant');
      ctx.commit('setLoading', true);

      const version = generateVersionHash(date);
      const data = JSON.stringify({
        search,
        sort_by: sortBy,
        version
      });

      const urlApi = api.GET_LIST_MERCHANT;
      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setDataMerchant', { payload: responseData });
      }
    },

    async downloadTemplate(ctx) {
      ctx.commit('setLoading', true);
      const urlApi = api.DOWNLOAD_TEMPLATE;
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${urlApi}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
      };
      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          if (error.response.status == '403') {
            showAlert(ctx, error.response.data.message, 'mdi-alert', 'red');
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return null;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async downloadMerchanPromo(ctx, { date, promoId }) {
      const version = generateVersionHash(promoId + date);
      const data = JSON.stringify({
        promo_id: promoId,
        version
      });

      const urlApi = api.DOWNLOAD_MERCHANT_PROMO;
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${urlApi}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => response)
        .catch((error) => {
          if (error.response.status == '403') {
            showAlert(ctx, error.response.data.message, 'mdi-alert', 'red');
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return null;
        })
        .finally(() => {});
    },

    async downloadFailed(ctx, { date, promoId, bulkId }) {
      ctx.commit('setLoading', true);

      const version = generateVersionHash(date);
      const data = JSON.stringify({
        promo_id: promoId,
        bulk_id: bulkId,
        version
      });
      const urlApi = api.DOWNLOAD_FAILED_MERCHANT_PROMO;
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${urlApi}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => response)
        .catch((error) => {
          if (error.response.status == '403') {
            showAlert(ctx, error.response.data.message, 'mdi-alert', 'red');
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return null;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async createPromo(ctx, { date, editAble }) {
      ctx.commit('setLoading', true);
      const version = generateVersionHash(date);
      const data = JSON.stringify({
        id: ctx.state.data.id,
        promo_type: ctx.state.data.promo_type,
        merchants: ctx.state.data.merchants,
        bulk_id: ctx.state.data.bulk_id,
        promo_name: ctx.state.data.promo_name,
        qr_method_npm: ctx.state.data.qr_method_npm,
        qr_method_cpm: ctx.state.data.qr_method_cpm,
        payment_type_on_us: ctx.state.data.payment_type_on_us,
        payment_type_off_us: ctx.state.data.payment_type_off_us,
        min_transaction: ctx.state.data.min_transaction,
        promo_period: ctx.state.data.promo_period,
        promo_quota_per_merchant: ctx.state.data.promo_quota_per_merchant,
        promo_quota_per_customer: ctx.state.data.promo_quota_per_customer,
        promo_quota_merchant_per_day:
          ctx.state.data.promo_quota_merchant_per_day,
        promo_quota_customer_per_day:
          ctx.state.data.promo_quota_customer_per_day,
        jenis_promo: ctx.state.data.jenis_promo,
        discount_type: ctx.state.data.discount_type,
        percent: ctx.state.data.percent,
        max_discount_amount: ctx.state.data.max_discount_amount,
        fix_amount: ctx.state.data.fix_amount,
        syarat_dan_ketentuan: ctx.state.data.syarat_dan_ketentuan,
        bulk_upload_status: ctx.state.data.bulk_upload_status,
        status: ctx.state.data.status,
        version
      });

      const controller = (ctrl) =>
        ctrl ? 'edit-promo/edit' : 'promo-merchant/create';

      const urlApi = `/index.php?r=api/v1/promo/${controller(editAble)}`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code === 200) {
        const message = editAble ? 'Update Success!' : 'Create Success!';
        showAlert(ctx, message, 'mdi-check-circle', 'green');
        ctx.commit('setFinishStep', true);
        resVal = responseData.data;
      }
      return resVal;
    },

    async bulkUpload(ctx, { file }) {
      const data = new FormData();
      data.append('file', file);
      ctx.commit('setOnUpload', true);

      ctx.commit('setDataVariable', {
        variable: 'bulk_upload_status',
        payload: true,
      });

      const failed = () => {
        ctx.commit('setOnUpload', false);
        showAlert(ctx, 'Gagal upload file !', 'mdi-alert', 'red');
      };
      const apiUrl = api.BULK_UPLOAD;
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${apiUrl}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      try {
        return await axios(config)
          .then((response) => {
            if (response.data.code == '200') {
              ctx.commit('setDataVariable', {
                variable: 'bulk_id',
                payload: response.data.data.bulk_id,
              });
            } else {
              failed();
              if (response.data.code == '302') {
                showAlert(ctx, response.data.data.message, 'mdi-alert', 'red');
              }
            }
            return response.data;
          })
          .catch((error) => {
            failed();
            if (error.response.status == '403') {
              showAlert(ctx, error.response.data.message, 'mdi-alert', 'red');
            } else if (error.response.status == '401') {
              ctx.dispatch('logout', null, { root: true });
            }
            return null;
          })
          .finally(() => {
            ctx.commit('setOnUpload', false);
          });
      } catch (error) {
        failed();
        return false;
      }
    },

    async bulkDelete(ctx, { date, bulkId }) {
      const version = generateVersionHash(date);
      const data = JSON.stringify({
        bulk_id: bulkId,
        version
      });
      const urlApi = api.BULK_DELETE;
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${urlApi}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config).then(() => {});
    },
  },
};
export default promo;
